import React, { Component } from 'react'
import { TABLA_DETALLE_ESPACIO_POR_CEREAL_LINEA_5 } from '../../../../../config/tables'
import MuiTable from '../../../../Forms/SharedComponents/containers/MuiTable'

export class TablaDetalleEspacioPorCerealLinea5View extends Component {
  render () {
    return (
      <MuiTable id={TABLA_DETALLE_ESPACIO_POR_CEREAL_LINEA_5} />
    )
  }
}
